import React from 'react';

import Link from '@/components/commons/link';

import styles from './RightPanel.module.css';

function RightPanelItem({ data }) {
    if (!data) {
        return null;
    }

    return (
        <div className={data.buttonStyles || styles.rightPanelItem}>
            <Link
                className="flex items-center"
                to={data.route}
            >
                <div className="w-[20px] h-[20px]">
                    {data.icon}
                </div>
                <span className={data.textStyles || 'pl-[5px] pt-[2px] text-cleanSlate text-[14px] font-semibold'}>{data.name}</span>
            </Link>
        </div>
    );
}

export default RightPanelItem;
